// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18sc9","icon":"styles_icon__2a1SJ"};